import { type DocumentNode, gql } from '@apollo/client';

/**
 * Deleted configuration structure
 */
export interface DeletedConfiguration {
  id: string;
  optionKey: string;
  optionValue: string | null;
  optionScope: string;
  imageData: string | null;
}

/**
 * Delete configuration payload structure
 */
export interface DeleteConfigurationPayload {
  configuration: DeletedConfiguration;
}

/**
 * Response structure for deleteConfiguration mutation
 */
export interface DeleteConfigResponse {
  deleteConfiguration: DeleteConfigurationPayload;
}

const deleteConfig: DocumentNode = gql`
  mutation configuration_delete {
    deleteConfiguration(configurationId: "Q29uZmlndXJhdGlvbk5vZGVUeXBlOjEyMg==") {
      configuration {
        id
        optionKey
        optionValue
        optionScope
        imageData
      }
    }
  }
`;

export default deleteConfig;
